import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 main_system_loader: { message: "idle" },
};

export const main_system_loader_Slice = createSlice({
 name: "main_system_loader",
 initialState,
 reducers: {
  success_main_system_loader: (state, action) => {
   const { token, tenant } = action?.payload;
   localStorage.setItem('dashboard_tenant', JSON.stringify(tenant));
   localStorage.setItem('dashboard_access', JSON.stringify(token));
   state.main_system_loader = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_main_system_loader: (state, action) => {
   state.main_system_loader = { status: app_consts.FAIL, message: action.payload };
  },
  reset_main_system_loader: (state) => {
   state.main_system_loader = { status: app_consts.IDLE };
  },
  loading_main_system_loader: (state) => {
   state.main_system_loader = { status: app_consts.LOADING };
  },
 }
});

export const { success_main_system_loader, fail_main_system_loader, reset_main_system_loader, loading_main_system_loader } = main_system_loader_Slice.actions;

export default main_system_loader_Slice.reducer;